// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { computerAndMonitor16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-computer-and-monitor': IconComputerAndMonitor;
    }
}

/**
 * The icon component for the 'computerAndMonitor' icon
 */
export class IconComputerAndMonitor extends IconSvg {
    public constructor() {
        super(computerAndMonitor16X16);
    }
}

registerIconSvg('icon-computer-and-monitor', IconComputerAndMonitor);
export const iconComputerAndMonitorTag = 'nimble-icon-computer-and-monitor';
